import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-level-security-password-checker',
  templateUrl: './level-security-password-checker.component.html',
  styleUrls: ['./level-security-password-checker.component.scss'],
  animations: [fadeInAnimation]
})
export class LevelSecurityPasswordCheckerComponent implements OnInit, OnChanges {

  barColorClass0 = 'grayPointColor';
  barColorClass1 = 'grayPointColor';
  barColorClass2 = 'grayPointColor';
  barColorClass3 = 'grayPointColor';

  strengthPassword = '';
  strengthPasswordTooltip = '';

  private colorsClass = ['redPointColor', 'orangePointColor', 'yellowPointColor', 'greenPointColor'];
  private tooltipStrengthPassword = ['Al menos una minúscula', 'Al menos una mayúscula', 'Al menos un número', 'Al menos 8 caracteres'];


  @Input() value: string;
  itemsSecurity: {
    lowercase: boolean,
    uppercase: boolean,
    minCharacters: boolean,
    number: boolean
  };
  lowercaseRegex: RegExp;
  upperCaseRegex: RegExp;
  numberRegex: RegExp;
  constructor() { }

  ngOnInit(): void {
    this.itemsSecurity = {
      lowercase: false,
      uppercase: false,
      minCharacters: false,
      number: false
    };

    this.strengthPassword = '';
    this.strengthPasswordTooltip = 'Contraseña insegura';

    this.lowercaseRegex = new RegExp('[a-z]+');
    this.upperCaseRegex = new RegExp('[A-Z]+');
    this.numberRegex = new RegExp('[0-9]+');
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      if (this.itemsSecurity) {
        this.itemsSecurity.minCharacters = this.value.length >= 8;
        this.itemsSecurity.lowercase = this.lowercaseRegex.test(this.value);
        this.itemsSecurity.uppercase = this.upperCaseRegex.test(this.value);
        this.itemsSecurity.number = this.numberRegex.test(this.value);

        // Logger.log('this.itemsSecureity: ', this.itemsSecurity);

        // Logger.log('total validaciones contraseñas completas: ',  Object.values(this.itemsSecurity).filter(item => item).length);

        this.setBarColors(4, 'grayPointColor');

        if (Object.values(this.itemsSecurity).filter(item => item).length > 0) {
          const c = this.getColor(Object.values(this.itemsSecurity).filter(item => item).length);

          this.setBarColors(c.index, c.color);
        }

        this.setTooltipPassword();
      }
    }
  }

  private getColor(numberCorrectValidations): { index: number, color: string } {
    let index = 0;
    if (numberCorrectValidations === 1) {
      index = 0;
      this.strengthPassword = 'Muy insegura';
    } else if (numberCorrectValidations === 2) {
      index = 1;
      this.strengthPassword = 'Insegura';
    } else if (numberCorrectValidations === 3) {
      index = 2;
      this.strengthPassword = 'Poco segura';
    } else if (numberCorrectValidations === 4) {
      index = 3;
      this.strengthPassword = 'Segura';
    } else {
      index = 4;
      this.strengthPassword = '';
    }
    return {
      index: index + 1,
      color: this.colorsClass[index]
    };
  }

  private setBarColors(count, col): void {
    for (let n = 0; n < count; n++) {
      this['barColorClass' + n] = col;
    }
  }

  private setTooltipPassword(): void {
    this.strengthPasswordTooltip = 'La contraseña debe tener: ';

    // tslint:disable:no-unused-expression
    this.itemsSecurity.minCharacters ? '' : (this.strengthPasswordTooltip += `${this.tooltipStrengthPassword[3]}. `);
    this.itemsSecurity.lowercase ? '' : (this.strengthPasswordTooltip += `${this.tooltipStrengthPassword[0]}. `);
    this.itemsSecurity.uppercase ? '' : (this.strengthPasswordTooltip += `${this.tooltipStrengthPassword[1]}. `);
    this.itemsSecurity.number ? '' : (this.strengthPasswordTooltip += `${this.tooltipStrengthPassword[2]}. `);


    if (Object.values(this.itemsSecurity).filter(item => item).length >= 4) {
      this.strengthPasswordTooltip = 'Contraseña segura';
    }
  }

  getSecurityValue(): any {
    return {
      percentage: Object.values(this.itemsSecurity).filter(item => item).length * 25,
      ...this.itemsSecurity
    };
  }

}
